// src/components/PhysicalCardBack.js

import React, { forwardRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import brandLogo from '../assets/logo/logo-white.png';

const PhysicalCardBack = forwardRef(({ baristaLink }, ref) => {
  return (
    <div ref={ref} className="print-card-container back">
      <h2 className="back-title">Grams Specialty Coffee</h2>
      
      {/* Le QR Code est maintenant directement au centre */}
      <QRCodeSVG
        value={baristaLink} // Utilise la prop directement
        size={250}
        bgColor="transparent"
        fgColor="#FFFFFF"
      />
      
      <img src={brandLogo} alt="Grams Logo" className="card-logo-icon" />
    </div>
  );
});

export default PhysicalCardBack;